import { render, staticRenderFns } from "./PersonMedicineSchedule.vue?vue&type=template&id=661b274c&scoped=true"
import script from "./PersonMedicineSchedule.vue?vue&type=script&lang=js"
export * from "./PersonMedicineSchedule.vue?vue&type=script&lang=js"
import style0 from "./PersonMedicineSchedule.vue?vue&type=style&index=0&id=661b274c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661b274c",
  null
  
)

export default component.exports